import * as actionTypes from "./ActionTypes"
import Request from "../components/api/Request";

const jwtDecode = require('jwt-decode');


export function loginSuccess(data) {
    return {
        type: actionTypes.LOGIN_SUCCESS,
        payload: data
    }
}

export function login(username, password) {
    return function (dispatch) {
        let url = "/auth/login";
        let data = {username, password};
        const request = new Request(url, "POST", data);
        request.run()
            .then(response => {
                let decoded = jwtDecode(response.data.data.token);
                localStorage.setItem('loggedIn', "true");
                localStorage.setItem('token', response.data.data.token);
                localStorage.setItem('username', decoded.username);
                localStorage.setItem('name', decoded.name);
                localStorage.setItem('roles', JSON.stringify(response.data.data.roles));
                dispatch(loginSuccess({
                    loggedIn: true,
                    username: decoded.username,
                    name: decoded.name,
                    roles:response.data.data.roles
                }));
            })
            .catch(error => {
                dispatch(loginSuccess({
                    loggedIn: false,
                    username: "",
                    name: "",
                    roles:[]
                }));
            });
    }
}


export function logout() {

    localStorage.setItem('loggedIn', "false");
    localStorage.setItem('token', "");
    localStorage.setItem('username', "");
    localStorage.setItem('name', "");
    localStorage.setItem('roles', JSON.stringify([]));
    return {
        type: actionTypes.LOGOUT_SUCCESS,
        payload: {
            loggedIn: false,
            username: "",
            name: "",
            roles:[]
        }
    }
}
